import {
  StudentOrParentActivityLatestDocument,
  StudentOrParentActivityLatestQuery,
  StudentOrParentActivityLatestQueryVariables,
} from '../types';
import { client } from '../../client';

export async function studentOrParentGetLatestActivity(
  variables: StudentOrParentActivityLatestQueryVariables,
): Promise<StudentOrParentActivityLatestQuery> {
  try {
    const result = await client.query<StudentOrParentActivityLatestQuery, StudentOrParentActivityLatestQueryVariables>({
      query: StudentOrParentActivityLatestDocument,
      variables,
      fetchPolicy: 'network-only',
    });
    return result.data;
  } catch (error) {
    throw Error(error);
  }
}
